import type { ComponentPropsWithoutRef, ElementRef } from 'react'
import { forwardRef } from 'react'

import * as SwitchR from '@radix-ui/react-switch'

import { classNames } from '@/utils/helpers.ts'

interface Props extends ComponentPropsWithoutRef<typeof SwitchR.Root> {
  isSmall?: boolean
  testId?: string
}

export const Switch = forwardRef<ElementRef<typeof SwitchR.Root>, Props>(
  (
    { className, id, checked, defaultChecked, isSmall, testId, ...props },
    ref,
  ) => {
    return (
      <SwitchR.Root
        ref={ref}
        id={id}
        checked={checked}
        defaultChecked={defaultChecked}
        data-testid={testId}
        className={classNames(
          'group relative h-[26px] w-[46px] rounded-[10px] border bg-secondary-300 px-[2px] py-[2px] aria-checked:bg-primary-500 [[aria-checked=true]&>*]:translate-x-[100%]',
          {
            'h-[20px] w-[35px]': isSmall,
          },
          {
            'cursor-not-allowed opacity-70': props.disabled,
          },
          className,
        )}
        {...props}
      >
        <SwitchR.Thumb
          className={classNames(
            'block h-[18px] w-[20px] rounded-[8px] bg-white shadow-sm transition-all',
            {
              'h-3.5 w-[14px]': isSmall,
            },
          )}
        />
      </SwitchR.Root>
    )
  },
)

Switch.displayName = 'Switch'
